import { useTranslation } from 'react-i18next';
import { Variant } from '@components/badge/src/badge.type';

import { AdmissionCardInfoProps, STATUS_TRANSLATION_KEYS, STATUS_VARIANT } from '../src/admission-card.type';

import { AdmissionCardBadges } from './admission-card-badges';
import { AdmissionCardDescription } from './admission-card-description';
import { AdmissionCardInteractive } from './admission-card-interactive';

export const AdmissionCardInfo = ({
  id,
  status,
  checked,
  listeners,
  attributes,
  isDragActive = false,
  isSelectActive,
  isMultiSelectActive,
  onChange,
  cardOpacity,
  color,
  name,
  tags,
  accessValidity,
  guestCapacity,
  soldItems,
  quantity,
  description,
  isDateVisible,
  onlinePrice,
  ddpPrice,
  formattedSalesEndsDate,
  formattedOnlinePrice,
  formatedDdpPrice,
  hideStockInfo = false,
}: AdmissionCardInfoProps) => {
  const { t } = useTranslation();
  const badgeVariant = status ? (STATUS_VARIANT[status] as Variant) : '';
  const statusTranslated = status ? t(STATUS_TRANSLATION_KEYS[status]) : '';

  return (
    <>
      <AdmissionCardInteractive
        id={id}
        sectionClassName='hidden sm:flex @sm:hidden'
        checked={checked}
        isDragActive={isDragActive}
        isSelectActive={isSelectActive}
        isMultiSelectActive={isMultiSelectActive}
        listeners={listeners}
        attributes={attributes}
        onChange={onChange}
      />
      <div className={`flex flex-col ${cardOpacity} w-full min-w-0 gap-2`}>
        <div className='flex flex-row items-center gap-1.5 sm:gap-2 @sm:gap-1.5 min-w-0'>
          <AdmissionCardInteractive
            id={id}
            sectionClassName='flex sm:hidden @sm:flex'
            checked={checked}
            isDragActive={isDragActive}
            isSelectActive={isSelectActive}
            isMultiSelectActive={isMultiSelectActive}
            listeners={listeners}
            attributes={attributes}
            onChange={onChange}
          />
          {color && <div className='w-3 h-3 rounded-full shrink-0' style={{ backgroundColor: `${color}` }}></div>}
          <span
            data-testid='admission-card--name'
            className='text-left text-subtitle-m text-primary line-clamp-2 sm:line-clamp-1 @sm:line-clamp-2 min-w-0'>
            {name}
          </span>
        </div>
        <AdmissionCardDescription
          description={description}
          isDateVisible={isDateVisible}
          onlinePrice={onlinePrice}
          ddpPrice={ddpPrice}
          formattedSalesEndsDate={formattedSalesEndsDate}
          formattedOnlinePrice={formattedOnlinePrice}
          formatedDdpPrice={formatedDdpPrice}
        />
        <AdmissionCardBadges
          {...{
            status,
            badgeVariant,
            statusTranslated,
            tags,
            accessValidity,
            guestCapacity,
            cardOpacity,
            soldItems,
            quantity,
            t,
            hideStockInfo,
          }}
        />
      </div>
    </>
  );
};
